module.exports = __webpack_public_path__ + "img/CM-KT-25-Chevy-Playful.748c02ed.jpg";